export const calulateOpsparingSum = aftaler => {
    if(!aftaler || !aftaler.length){
        return 0;
    }
    return aftaler?.map(x => x.opsparing ?? 0).reduce((sum, x) => sum + x);
};
export const getLatestScrape = scrapes => {
    if (!scrapes.length) return undefined;
    return sortScrapesByDate(scrapes)[0];
};

export const sortScrapesByDate = scrapes => {
    if (!scrapes.length) return undefined;
    return scrapes.sort((a, b) => {
        if(b?.profil?.udskrevetDato === a?.profil?.udskrevetDato){
            return new Date(b?.createdAt) - new Date(a?.createdAt);
        }
        return new Date(b?.profil?.udskrevetDato) - new Date(a?.profil?.udskrevetDato);
    });
};
